import { render, staticRenderFns } from "./newFileEdit.vue?vue&type=template&id=3288feb3"
import script from "./newFileEdit.vue?vue&type=script&lang=js"
export * from "./newFileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports